'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFiberNew = function MdFiberNew(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 23.4v-8.4h-2v7.5h-1.9v-5.9h-2.1v5.9h-1.8v-7.5h-2.2v8.4c0 0.9 0.8 1.6 1.8 1.6h6.6c0.9 0 1.6-0.7 1.6-1.6z m-11.6-6.3v-2.1h-6.6v10h6.6v-2.1h-4.1v-1.8h4.1v-2.1h-4.1v-1.9h4.1z m-8.4 7.9v-10h-2v5.9l-4.2-5.9h-2v10h2v-5.9l4.3 5.9h1.9z m19.3-18.4c1.8 0 3.2 1.5 3.2 3.4v20c0 1.9-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.5-3.2-3.4v-20c0-1.9 1.4-3.4 3.2-3.4h26.8z' })
        )
    );
};

exports.default = MdFiberNew;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/fiber-new.js
// module id = 2856
// module chunks = 0